import React from "react";

// Inline SVG wordmark + symbol for Sonnenwerk
export default function Logo({ className = "", variant = "dark" }) {
  const textColor = variant === "light" ? "#FDFCF9" : "#1A1D20";
  return (
    <div
      data-testid="brand-logo"
      className={`inline-flex items-center gap-2.5 select-none ${className}`}
    >
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <defs>
          <linearGradient id="sw-sun" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#FACC15" />
            <stop offset="100%" stopColor="#CA9A06" />
          </linearGradient>
        </defs>
        {/* Outer rays */}
        <g stroke="#1A1D20" strokeWidth="1.6" strokeLinecap="round">
          <line x1="16" y1="2.5" x2="16" y2="6" />
          <line x1="16" y1="26" x2="16" y2="29.5" />
          <line x1="2.5" y1="16" x2="6" y2="16" />
          <line x1="26" y1="16" x2="29.5" y2="16" />
          <line x1="6.5" y1="6.5" x2="9" y2="9" />
          <line x1="23" y1="23" x2="25.5" y2="25.5" />
          <line x1="6.5" y1="25.5" x2="9" y2="23" />
          <line x1="23" y1="9" x2="25.5" y2="6.5" />
        </g>
        {/* Solar cell hexagon */}
        <polygon
          points="16,7 23.5,11.5 23.5,20.5 16,25 8.5,20.5 8.5,11.5"
          fill="url(#sw-sun)"
          stroke="#1A1D20"
          strokeWidth="1.2"
        />
        {/* inner grid lines */}
        <g stroke="#1A1D20" strokeWidth="0.7" opacity="0.55">
          <line x1="16" y1="7" x2="16" y2="25" />
          <line x1="8.5" y1="11.5" x2="23.5" y2="20.5" />
          <line x1="23.5" y1="11.5" x2="8.5" y2="20.5" />
        </g>
      </svg>
      <span
        className="font-display font-bold tracking-tight text-[1.15rem]"
        style={{ color: textColor }}
      >
        Sonnen<span style={{ color: "#EAB308" }}>werk</span>
      </span>
    </div>
  );
}
